import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import LinearProgress from "@material-ui/core/LinearProgress";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { grey } from "@mui/material/colors";

import "./DialogLoaderHoneyLoad.scss";

import runtimeEnv from "@mars/heroku-js-runtime-env";
import fetchAPI from "../../../../components/utils/fetchAPI";

const env = runtimeEnv();
export default class DialogLoaderHoneyLoad extends Component {
  state = {
    localControl: true,
    message:
      typeof this.props.message !== "undefined"
        ? this.props.message
        : "Procesando",
  };

  closeModal = () => {
    this.setState({
      localControl: false,
    });
  };

  onCloseModal = (e) => {
    this.props.handleClose(e);
  };

  render() {
    return (
      <Dialog onClose={this.onCloseModal} open={this.props.opened}>
        <Grid
          container
          item
          xs={12}
          spacing={0}
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            <div className={"dialog__icon dialog__icon--updating"}></div>
          </Grid>
          <Grid item xs={12}>
            <div className={"dialog__message"}>{this.props.message}</div>
          </Grid>
        </Grid>
      </Dialog>
    );
  }
}
